"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _sortableTableStyle = require("./sortableTable.style.js");

var _useSortableData2 = _interopRequireDefault(require("./customHooks/useSortableData.js"));

var SortableTable = function SortableTable(_ref) {
  var data = _ref.data,
      keys = _ref.keys,
      _ref$defaultSortKey = _ref.defaultSortKey,
      defaultSortKey = _ref$defaultSortKey === void 0 ? keys[0].key : _ref$defaultSortKey,
      props = (0, _objectWithoutProperties2.default)(_ref, ["data", "keys", "defaultSortKey"]);

  var _useSortableData = (0, _useSortableData2.default)(data, {
    key: defaultSortKey,
    direction: 'ascending'
  }),
      items = _useSortableData.items,
      requestSort = _useSortableData.requestSort,
      sortConfig = _useSortableData.sortConfig;

  var getSortOrderFor = function getSortOrderFor(name) {
    if (!sortConfig) {
      return;
    }

    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  var renderTableHead = function renderTableHead() {
    return keys.map(function (item) {
      return /*#__PURE__*/_react.default.createElement("th", {
        key: item.key
      }, /*#__PURE__*/_react.default.createElement(_sortableTableStyle.StyledTableHeadButton, {
        disabled: !item.sortable,
        type: "button",
        onClick: function onClick() {
          return requestSort(item.key);
        },
        sortOrder: getSortOrderFor(item.key)
      }, item.label));
    });
  };

  var renderTableRow = function renderTableRow(row) {
    var tableRow = [];

    for (var key in row) {
      key !== 'id' && tableRow.push( /*#__PURE__*/_react.default.createElement("td", {
        key: key + row.id
      }, row[key]));
    }

    return tableRow;
  };

  var renderTableBody = function renderTableBody() {
    return items.map(function (item) {
      return /*#__PURE__*/_react.default.createElement("tr", {
        key: item.id
      }, renderTableRow(item));
    });
  };

  return /*#__PURE__*/_react.default.createElement(_sortableTableStyle.StyledTableWrapper, props, /*#__PURE__*/_react.default.createElement(_sortableTableStyle.StyledTable, null, /*#__PURE__*/_react.default.createElement(_sortableTableStyle.StyledTableHead, null, /*#__PURE__*/_react.default.createElement("tr", null, renderTableHead())), /*#__PURE__*/_react.default.createElement(_sortableTableStyle.StyledTableBody, null, renderTableBody()), props.children));
};

var _default = SortableTable;
exports.default = _default;